import React from 'react'
import ReactDOM from 'react-dom'

// Import locations components
import LocationsIndex from './components/admin_app/locations/LocationsIndex'
import LocationBoundaryEditor from './components/admin_app/location_boundaries/LocationBoundaryEditor'
import GeojsonUploader from './components/admin_app/geojson_imports/GeojsonUploader'
import BulkCouponsManager from './components/admin_app/bulk_coupons/BulkCouponsManager'
import AdminGiftCodes from './components/admin_app/gift_codes/AdminGiftCodes'

// Make components available globally
window.React = React;
window.ReactDOM = ReactDOM;
window.LocationsIndex = LocationsIndex;
window.LocationBoundaryEditor = LocationBoundaryEditor;
window.GeojsonUploader = GeojsonUploader;
window.BulkCouponsManager = BulkCouponsManager;
window.AdminGiftCodes = AdminGiftCodes;

window.App = {
  init: function() {
    FroalaEditor.DefineIcon('inlineStyle', {SRC: 'https://image.flaticon.com/icons/png/128/2247/2247356.png', ALT: 'Letter Spacing', template: 'image'});
  },

  FroalaEditor: {
    init: function(opts) {
      opts = opts || {}
      var klass = opts.klass || 'builder__froala';
      var buttons = ['paragraphFormat', 'bold', 'italic', 'underline', 'lineHeight', 'inlineStyle', 'align', 'fontFamily',
                    'fontSize', 'color', 'insertLink', 'formatOL', 'formatUL', 'html', 'clearFormatting'//, 'photoInsert', 'iconInsert'
                    ].concat(opts.buttons || []);
      var char_limit = opts.charCounterMax || -1;

      if (opts.noButtons) {
        buttons = [];
      }

      new FroalaEditor('.' + klass, {toolbarButtons: buttons,
                                  toolbarButtonsMD: buttons,
                                  toolbarButtonsSM: buttons,
                                  toolbarButtonsXS: buttons,
                                  linkAlwaysBlank: true,
                                  quickInsertButtons: ['photoInsert', 'ul', 'ol', 'hr'],
                                  imageEditButtons: ['imageAlt', 'imageCaption', 'imageRemove'],
                                  imageResize: false,
                                  charCounterMax: char_limit,
                                  fontFamily: {
                                    "Open Sans": "Open Sans",
                                    "avenir, sans-serif": "Avenir",
                                    "helvetica, sans-serif": "Helvetica",
                                    "arial, sans-serif": "Arial",
                                    "Playfair Display, serif": "Playfair Display",
                                    "Georgia, serif": "Georgia", 
                                    "Times New Roman, serif": "Times New Roman"
                                  },
                                  fontFamilyDefaultSelection: "Open Sans",
                                  editorClass: 'froala-editor-default-styles',
                                  fontSize: ['8', '9', '10', '11', '12', '14', '16', '18', '20', '22', '24', '30', '36'],
                                  lineHeights: {
                                      Default: '',
                                      Single: '100%',
                                      '1.15': '115%',
                                      '1.5': '150%',
                                      Double: '200%'
                                  },
                                  inlineStyles: {
                                    'Letter Spacing: 0': 'letter-spacing: 0px;',
                                    'Letter Spacing: 0.5': 'letter-spacing: 0.5px;',
                                    'Letter Spacing: 1': 'letter-spacing: 1px;'
                                  },
                                  height: opts.height || 200,
                                  pasteDeniedAttrs: ['style'],
                                  key: 'SDB17hA5B6D5E4H4F4gpxjlgdvlbcjnflG5hcj1rA1C7A6D6E1D4G3E1C10A6==',
                                  attribution: false
                                });

    }
  }
};

// Customer.io Collections Update Progress
document.addEventListener('DOMContentLoaded', function() {
  const updateBtn = document.getElementById('update-all-btn');
  if (!updateBtn) return; // Exit if not on the customerio collections page
  
  const progressContainer = document.getElementById('progress-container');
  const progressBar = document.getElementById('progress-bar');
  const progressPercentage = document.getElementById('progress-percentage');
  const progressText = document.getElementById('progress-text');
  const completedCount = document.getElementById('completed-count');
  const totalCount = document.getElementById('total-count');
  
  let pollInterval = null;
  let currentJobId = null;
  
  updateBtn.addEventListener('click', function() {
    if (confirm('Are you sure you want to update ALL collections in Customer.io? This will update Offers, Upcoming Offers, Newsletter Reviews, Guides, Events, and City Stats.')) {
      startUpdate();
    }
  });
  
  function startUpdate() {
    // Disable button and show progress
    updateBtn.disabled = true;
    updateBtn.textContent = 'Updating...';
    updateBtn.classList.add('opacity-50', 'cursor-not-allowed');
    progressContainer.style.display = 'block';
    
    // Start the update via AJAX
    fetch(window.customerioUpdateAllPath, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      // Store the job ID
      if (data.job_id) {
        currentJobId = data.job_id;
      }
      // Start polling for progress
      pollProgress();
      pollInterval = setInterval(pollProgress, 1000); // Poll every second
    })
    .catch(error => {
      console.error('Error starting update:', error);
      resetButton();
      alert('Failed to start update. Please try again.');
    });
  }
  
  function pollProgress() {
    const url = currentJobId 
      ? window.customerioJobProgressPath + '?job_id=' + currentJobId
      : window.customerioJobProgressPath;
      
    fetch(url)
      .then(response => response.json())
      .then(data => {
        updateProgressUI(data);
        
        // Update UI based on status
        if (data.status === 'queued') {
          progressBar.classList.add('bg-yellow-500');
          progressBar.classList.remove('bg-green-600');
        } else if (data.status === 'running') {
          progressBar.classList.add('bg-green-600');
          progressBar.classList.remove('bg-yellow-500');
          // Show indeterminate progress since we can't track exact progress
          progressBar.style.width = '60%';
          progressPercentage.textContent = 'Processing...';
        }
        
        // Stop polling if job is complete
        if (!data.running && data.status === 'completed') {
          clearInterval(pollInterval);
          progressBar.style.width = '100%';
          progressPercentage.textContent = '100%';
          progressText.textContent = '✓ All collections updated successfully!';
          progressBar.classList.remove('bg-green-600');
          progressBar.classList.add('bg-green-500');
          currentJobId = null;
          
          setTimeout(() => {
            resetButton();
            // Reload the page after a delay to show updated data
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }, 500);
        }
      })
      .catch(error => {
        console.error('Error polling progress:', error);
      });
  }
  
  function updateProgressUI(data) {
    if (data.status !== 'running') {
      // Only update width if not in running state (running state is handled above)
      const percentage = data.percentage || 0;
      progressBar.style.width = percentage + '%';
      progressPercentage.textContent = percentage + '%';
    }
    progressText.textContent = data.current_task || 'Processing...';
    completedCount.textContent = data.completed || 0;
    totalCount.textContent = data.total || 6;
  }
  
  function resetButton() {
    updateBtn.disabled = false;
    updateBtn.textContent = 'Update All Collections';
    updateBtn.classList.remove('opacity-50', 'cursor-not-allowed');
  }
});
